import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { NotificationItem } from '@features/notifications/models/notification-item.model';
import { NotificationType } from '@shared-features/enums/shared-enums.enum';

const NOTIFICATION_ICONS: Record<NotificationType, string> = {
  [NotificationType.Shipment]: 'outline-truck',
  [NotificationType.Invoice]: 'outline-card',
  [NotificationType.Chat]: 'outline-messages',
};

@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss']
})
export class NotificationItemComponent implements OnChanges {

  @Input() notification: NotificationItem;
  @Output() notificationClicked = new EventEmitter<NotificationItem>();

  icon = 'outline-notification';
  timeLabel = '';

  constructor(private translateService: TranslateService) { }

  ngOnChanges(): void {
    this.icon = NOTIFICATION_ICONS[this.notification?.type] || 'outline-notification';
    this.timeLabel = this.formatTime(this.notification?.createdAt);
  }

  onNotificationClicked() {
    this.notificationClicked.emit(this.notification);
  }

  // Relative time for today, "Yesterday", then a plain date.
  private formatTime(createdAt: number): string {
    if (!createdAt) { return ''; }
    const date = moment(createdAt).locale(this.translateService.currentLang?.startsWith('ar') ? 'ar' : 'en');
    if (date.isSame(moment(), 'day')) { return date.fromNow(); }
    if (date.isSame(moment().subtract(1, 'day'), 'day')) { return this.translateService.instant('Notifications.Yesterday'); }
    return date.format('D MMM YYYY');
  }
}
